import { applyValuesToContainer } from "../../lib/applyValues";

export type AcroFormValues = { [name: string]: string };

export function applySectionValues(containerSelector: string, values: AcroFormValues) {
  const container = document.querySelector(containerSelector);
  if (!container || !values || Object.keys(values).length === 0) return;

  setTimeout(() => {
    const freshContainer = document.querySelector(containerSelector);
    if (freshContainer) {
      applyValuesToContainer(freshContainer as Element, values, true);
    }
  }, 500);
}
